import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import UILink from 'UIComponents/link/UILink';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIDialogHeaderImage from 'UIComponents/dialog/UIDialogHeaderImage';
import UIModal from 'UIComponents/dialog/UIModal';
import { H2 } from 'UIComponents/elements/headings';
import UIIllustration from 'UIComponents/image/UIIllustration';
import UIFlex from 'UIComponents/layout/UIFlex';
import UICopyInput from 'UIComponents/input/UICopyInput';
import { getCommerceHomeUrl, getWebsitesURL } from 'growth-payments-core/urls/urls';
import Confetti from 'growth-onboarding-shared-components/transitions/Confetti';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ConfettiTransition = styled.div.withConfig({
  displayName: "UseCaseTourCompleteModal__ConfettiTransition",
  componentId: "l6ee1o-0"
})(["height:200%;left:-50%;overflow:hidden;pointer-events:none;position:absolute;top:-60px;width:200%;"]);
const UseCaseTourCompleteModal = ({
  onClose,
  websiteLink
}) => {
  return /*#__PURE__*/_jsxs(UIModal, {
    "data-test-id": "useCaseTourCompleteModal",
    use: "conversational",
    width: 500,
    onEsc: onClose,
    children: [/*#__PURE__*/_jsx(ConfettiTransition, {
      children: /*#__PURE__*/_jsx(Confetti, {})
    }), /*#__PURE__*/_jsx(UIDialogHeaderImage, {
      offsetTop: 120,
      children: /*#__PURE__*/_jsx(UIIllustration, {
        name: "success"
      })
    }), /*#__PURE__*/_jsxs(UIDialogHeader, {
      className: "text-center p-top-1 p-bottom-4",
      children: [/*#__PURE__*/_jsx(UIDialogCloseButton, {
        "data-test-id": "useCaseTourCompleteModal-close",
        onClick: onClose
      }), /*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "useCaseTourCompleteModal.header"
        })
      })]
    }), /*#__PURE__*/_jsxs(UIDialogBody, {
      className: "text-left",
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "useCaseTourCompleteModal.messagePublished"
      }), /*#__PURE__*/_jsx("div", {
        className: "align-start p-top-2",
        children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: "useCaseTourCompleteModal.messageFindAll_jsx",
          options: {
            href: getWebsitesURL(),
            external: true
          },
          elements: {
            Link: UILink
          }
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "align-start p-top-5",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "useCaseTourCompleteModal.shareLink.message"
        })
      }), /*#__PURE__*/_jsx(UICopyInput, {
        className: "m-top-2",
        value: websiteLink
      })]
    }), /*#__PURE__*/_jsx(UIDialogFooter, {
      children: /*#__PURE__*/_jsx(UIFlex, {
        align: "center",
        justify: "center",
        direction: "column",
        wrap: "wrap",
        children: /*#__PURE__*/_jsx(UILink, {
          "data-test-id": "useCaseTourCompleteModal-backToGuide",
          href: getCommerceHomeUrl(),
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "useCaseTourCompleteModal.backToCommerce"
          })
        })
      })
    })]
  });
};
export default UseCaseTourCompleteModal;